/**************************************************
 * Nombre:       Home_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import linea from '../../../Recursos/Graficos/linea.svg'
import Tarjeta_Categoria from "../../Tarjetas/Tarjeta_Categoria";
import Tarjeta_Condiciones from "../../Tarjetas/Tarjeta_Condiciones";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Home_Categorias = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}

                    >

                        <Grid container size={{xs: 12, sm: 12, md: 3}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <Typography sx={{
                                fontSize: sCell ? 18 : 20,
                                fontWeight: 800,
                                lineHeight: 1.2,
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                                EXPLORA NUESTRAS CATEGORIAS
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'flex-start'}}>
                            <img src={linea} width={'100%'}/>
                        </Grid>


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 11}}
                            spacing={sCell ? 3 : 6}
                            sx={{mt: sCell ? 6 : 8}}
                        >

                            {items.map((item, i) => (
                                <Grid container size={{xs: 6, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Categoria/>
                                </Grid>
                            ))}

                        </Grid>

                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={2}
                            sx={{
                                mt: 8
                            }}
                        >


                            {itemsDos.map((item, i) => (
                                <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Condiciones/>
                                </Grid>
                            ))}

                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Categorias

const items = [1, 2, 3, 4]

const itemsDos = [1, 2, 3]